var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 68 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 17.1415V59.8896L24.021 52.6561L44.421 62.6564L61.2 55.5995V12.8547L65.6302 10.9946C65.8889 10.8859 66.1711 10.8419 66.4514 10.8665C66.7318 10.891 67.0015 10.9835 67.2364 11.1355C67.4713 11.2875 67.6641 11.4943 67.7973 11.7373C67.9306 11.9804 68.0003 12.2521 68 12.528V59.9997L44.2 70L23.8 59.9997L2.3698 69.0033C2.11111 69.112 1.82893 69.1561 1.54858 69.1315C1.26824 69.1069 0.99851 69.0145 0.763596 68.8625C0.528683 68.7105 0.33594 68.5037 0.202664 68.2606C0.0693878 68.0176 -0.000249751 67.7459 6.73031e-07 67.4699V19.9983L6.8 17.1415ZM48.4262 34.1421L34 48.2826L19.5738 34.1421C16.7212 31.3448 14.7786 27.781 13.9917 23.9014C13.2049 20.0217 13.6091 16.0004 15.1532 12.346C16.6973 8.69152 19.312 5.56804 22.6667 3.37049C26.0214 1.17293 29.9654 0 34 0C38.0346 0 41.9786 1.17293 45.3333 3.37049C48.688 5.56804 51.3027 8.69152 52.8468 12.346C54.3909 16.0004 54.7951 20.0217 54.0083 23.9014C53.2214 27.781 51.2788 31.3448 48.4262 34.1421ZM34 38.8556L43.6152 29.4253C45.5176 27.5607 46.8133 25.1848 47.3384 22.5982C47.8635 20.0116 47.5944 17.3304 46.5652 14.8938C45.5359 12.4571 43.7928 10.3744 41.5562 8.90908C39.3196 7.44377 36.69 6.66165 34 6.66165C31.31 6.66165 28.6804 7.44377 26.4438 8.90908C24.2072 10.3744 22.4641 12.4571 21.4348 14.8938C20.4056 17.3304 20.1365 20.0116 20.6616 22.5982C21.1867 25.1848 22.4824 27.5607 24.3848 29.4253L34 38.8556Z",
    fill: "#72C0B0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.2fdd139b54ff443d2ee7d00c42bab487.svg";
export { ForwardRef as ReactComponent };